export const EXCMDEVICETYPE_DELETE_RESET = 'EXCMDEVICETYPE_DELETE_RESET'
export const EXCMDEVICETYPE_DELETE_SET_ERROR = 'EXCMDEVICETYPE_DELETE_SET_ERROR'
export const EXCMDEVICETYPE_DELETE_SET_DELETED = 'EXCMDEVICETYPE_DELETE_SET_DELETED'
export const EXCMDEVICETYPE_DELETE_TOGGLE_LOADING = 'EXCMDEVICETYPE_DELETE_TOGGLE_LOADING'
